import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SHADOWS } from '../../settings/shadows';

const styles = StyleSheet.create({
  container: {
    maxWidth: 400,
    width: '100%',
    alignItems: 'stretch',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    ...SHADOWS.softShadow,
    padding: 20,
    backgroundColor: 'white',
    margin: 10,
  },
});

function Card(props) {
  return <View style={styles.container}>{props.children}</View>;
}

export default Card;
